export const INITIAL_CAMPAIGN_VERSION = 1;
export const STICKY_COLUMN_LIMIT = 2;
